/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { paths_1api_1v1_1pipeline_1cost_stats_get_responses_200_content_application_1json_schema_properties_rows_items } from '../models/paths_1api_1v1_1pipeline_1cost_stats_get_responses_200_content_application_1json_schema_properties_rows_items';
import type { paths_1api_1v1_1pipeline_1llm_models_get_parameters_1_schema } from '../models/paths_1api_1v1_1pipeline_1llm_models_get_parameters_1_schema';
import type { paths_1api_1v1_1pipeline_1llm_pricing_post_responses_201_content_application_1json_schema } from '../models/paths_1api_1v1_1pipeline_1llm_pricing_post_responses_201_content_application_1json_schema';
import type { paths_1api_1v1_1pipeline_1llm_pricing_post_responses_201_content_application_1json_schema_properties_status } from '../models/paths_1api_1v1_1pipeline_1llm_pricing_post_responses_201_content_application_1json_schema_properties_status';
import type { paths_1api_1v1_1pipeline_1runs_get_responses_200_content_application_1json_schema_items } from '../models/paths_1api_1v1_1pipeline_1runs_get_responses_200_content_application_1json_schema_items';
import type { paths_1api_1v1_1pipeline_1runs_get_responses_200_content_application_1json_schema_items_properties_status } from '../models/paths_1api_1v1_1pipeline_1runs_get_responses_200_content_application_1json_schema_items_properties_status';
import type { CancelablePromise } from 'core-fe-lib/openapi/core/core/CancelablePromise';
import { OpenAPI } from 'core-fe-lib/openapi/core/core/OpenAPI';
import { request as __request } from 'core-fe-lib/openapi/core/core/request';
export class PipelineService {
    /**
     * List recent pipeline runs with pagination
     * @param limit
     * @param offset
     * @param batchLabel
     * @returns any Paginated list of runs
     * @throws ApiError
     */
    public static listRuns(
        limit: number = 20,
        offset?: number,
        batchLabel?: string,
    ): CancelablePromise<Array<{
        id: string;
        batch_id: string;
        batch_label: string;
        label: string;
        meta?: Record<string, any>;
        status: 'pending' | 'running' | 'success' | 'failed' | 'skipped';
        readonly tenant_id: string;
        created_at: string;
        finished_at?: string;
    }>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/pipeline/runs',
            query: {
                'limit': limit,
                'offset': offset,
                'batchLabel': batchLabel,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Get a single run with its tasks
     * @param runId
     * @returns any Run with tasks
     * @throws ApiError
     */
    public static getRun(
        runId: string,
    ): CancelablePromise<{
        run: paths_1api_1v1_1pipeline_1runs_get_responses_200_content_application_1json_schema_items;
        tasks: Array<{
            id: string;
            run_id: string;
            stage_index: number;
            stage_name: string;
            name: string;
            handler_type: string;
            status: paths_1api_1v1_1pipeline_1runs_get_responses_200_content_application_1json_schema_items_properties_status;
            progress: number;
            readonly tenant_id?: string;
            started_at?: string;
            finished_at?: string;
        }>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/pipeline/runs/{runId}',
            path: {
                'runId': runId,
            },
            errors: {
                401: `Unauthorized`,
                404: `Run not found`,
            },
        });
    }
    /**
     * SSE stream for a single run (snapshot + live events)
     * @param runId
     * @returns string Server-Sent Events stream
     * @throws ApiError
     */
    public static streamRun(
        runId: string,
    ): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/pipeline/runs/{runId}/stream',
            path: {
                'runId': runId,
            },
        });
    }
    /**
     * List all runs in a batch
     * @param batchId
     * @returns paths_1api_1v1_1pipeline_1runs_get_responses_200_content_application_1json_schema_items List of runs
     * @throws ApiError
     */
    public static listRunsByBatch(
        batchId: string,
    ): CancelablePromise<Array<paths_1api_1v1_1pipeline_1runs_get_responses_200_content_application_1json_schema_items>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/pipeline/batches/{batchId}/runs',
            path: {
                'batchId': batchId,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Demuxed SSE stream for all runs in a batch
     * @param batchId
     * @returns string Server-Sent Events stream (demuxed by run_id)
     * @throws ApiError
     */
    public static streamBatch(
        batchId: string,
    ): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/pipeline/batches/{batchId}/stream',
            path: {
                'batchId': batchId,
            },
        });
    }
    /**
     * List all LLM pricing entries
     * @returns paths_1api_1v1_1pipeline_1llm_pricing_post_responses_201_content_application_1json_schema List of LLM pricing entries
     * @throws ApiError
     */
    public static listLlmPricing(): CancelablePromise<Array<paths_1api_1v1_1pipeline_1llm_pricing_post_responses_201_content_application_1json_schema>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/pipeline/llm-pricing',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Create an LLM pricing entry
     * @param requestBody
     * @returns any Created
     * @throws ApiError
     */
    public static createLlmPricing(
        requestBody: {
            llm_key: string;
            provider: string;
            label: string;
            capabilities: Array<paths_1api_1v1_1pipeline_1llm_models_get_parameters_1_schema>;
            /**
             * Defaults to `active` when omitted.
             */
            status?: paths_1api_1v1_1pipeline_1llm_pricing_post_responses_201_content_application_1json_schema_properties_status;
            upstream_id?: string;
            notes?: string;
            price_input_per_million: number;
            price_output_per_million: number;
            valid_from?: string;
            valid_to?: string;
        },
    ): CancelablePromise<{
        id: string;
        /**
         * Stable provider-prefixed identifier (e.g. `googleai/gemini-2.5-flash`).
         */
        llm_key: string;
        /**
         * Routing prefix — `googleai`, `anthropic`, `openai`, `scaleway`, `ovh`, `mistral`, `private`, …
         */
        provider: string;
        /**
         * Human-readable name for selector dropdowns.
         */
        label: string;
        capabilities: Array<paths_1api_1v1_1pipeline_1llm_models_get_parameters_1_schema>;
        /**
         * Registry lifecycle state. `active` shows in every model selector;
         * `inactive` is discovered-but-not-enabled (where provider sync drops new
         * models); `obsolete` is gone from the provider's live API (hidden from
         * selectors, kept for cost history).
         *
         */
        status: 'active' | 'inactive' | 'obsolete';
        /**
         * For `private*` rows, the upstream HuggingFace model ID handed to vLLM/Atlas.
         */
        upstream_id?: string;
        notes?: string;
        price_input_per_million: number;
        price_output_per_million: number;
        valid_from?: string;
        valid_to?: string;
        created_at: string;
        updated_at: string;
        /**
         * Embedded only when `listLLMModels` is called with a `taskType`
         * query param. Lets selectors render rating chips inline.
         *
         */
        stats?: {
            /**
             * Implicit-signal count over the window (excludes thumbs).
             */
            samples: number;
            /**
             * Thumbs count over the window.
             */
            votes: number;
            reliability?: number;
            formatting?: number;
            userApproval?: number;
        };
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/pipeline/llm-pricing',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Update an LLM pricing entry
     * @param id
     * @param requestBody
     * @returns paths_1api_1v1_1pipeline_1llm_pricing_post_responses_201_content_application_1json_schema Updated
     * @throws ApiError
     */
    public static updateLlmPricing(
        id: string,
        requestBody: {
            llm_key: string;
            provider: string;
            label: string;
            capabilities: Array<paths_1api_1v1_1pipeline_1llm_models_get_parameters_1_schema>;
            /**
             * Defaults to `active` when omitted.
             */
            status?: paths_1api_1v1_1pipeline_1llm_pricing_post_responses_201_content_application_1json_schema_properties_status;
            upstream_id?: string;
            notes?: string;
            price_input_per_million: number;
            price_output_per_million: number;
            valid_from?: string;
            valid_to?: string;
        },
    ): CancelablePromise<paths_1api_1v1_1pipeline_1llm_pricing_post_responses_201_content_application_1json_schema> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/pipeline/llm-pricing/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                404: `Not found`,
            },
        });
    }
    /**
     * Delete an LLM pricing entry
     * @param id
     * @returns void
     * @throws ApiError
     */
    public static deleteLlmPricing(
        id: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/pipeline/llm-pricing/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                404: `Not found`,
            },
        });
    }
    /**
     * List LLM registry entries (one row per llm_key) for use by model selectors.
     * Filters apply server-side; the response is sorted by provider then label.
     * When `taskType` is provided, each row gets an embedded `stats` block
     * with the three rating numbers (reliability / formatting / userApproval)
     * for that task type — lets the selector render rating chips inline.
     *
     * @param provider
     * @param capability
     * @param activeOnly
     * @param taskType Embed feedback stats for this task type (e.g. "scholar_segmentation").
     * @returns paths_1api_1v1_1pipeline_1llm_pricing_post_responses_201_content_application_1json_schema List of registry entries
     * @throws ApiError
     */
    public static listLlmModels(
        provider?: string,
        capability?: 'text' | 'vision' | 'ocr' | 'layout' | 'embedder' | 'reasoning' | 'code' | 'audio' | 'moderation',
        activeOnly: boolean = true,
        taskType?: string,
    ): CancelablePromise<Array<paths_1api_1v1_1pipeline_1llm_pricing_post_responses_201_content_application_1json_schema>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/pipeline/llm-models',
            query: {
                'provider': provider,
                'capability': capability,
                'activeOnly': activeOnly,
                'taskType': taskType,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Record one rating signal for a model. Typically a thumbs up/down on
     * a specific task row in the run-detail UI. The aggregator keys on
     * (llm_key, task_type), so per-task-type ratings light up in selectors.
     *
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static recordLlmFeedback(
        requestBody: {
            llm_key: string;
            /**
             * Handler type, e.g. "scholar_segmentation", "scholar_agent".
             */
            task_type: string;
            signal: 'thumbs_up' | 'thumbs_down';
            run_id?: string;
            task_id?: string;
            note?: string;
        },
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/pipeline/llm-feedback',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Upsert the curated default LLM registry. Re-running it reconciles
     * labels/capabilities/prices but preserves IDs (and therefore cost history).
     * Admin only.
     *
     * @returns any Seed result
     * @throws ApiError
     */
    public static seedLlmModels(): CancelablePromise<{
        /**
         * Number of registry entries upserted.
         */
        upserted: number;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/pipeline/llm-models/seed',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * Reconcile the registry against every provider's live /v1/models.
     * New models are added as `inactive` (await review); registry slugs that
     * vanished from a provider are marked `obsolete`; previously-obsolete
     * slugs found live again are revived to `inactive`. Providers with a
     * missing API key or a failed fetch are skipped (never mass-obsoleted),
     * and `private*` is never touched. Admin only.
     *
     * @returns any Sync result
     * @throws ApiError
     */
    public static syncLlmModels(): CancelablePromise<{
        providers: Array<{
            provider: string;
            /**
             * false when the provider's API key was missing or the /v1/models request failed (then nothing was changed for it).
             */
            fetched: boolean;
            /**
             * Present when fetched=false — why this provider was skipped.
             */
            error?: string;
            /**
             * Number of models the provider's live API returned.
             */
            live_count: number;
            /**
             * Slugs newly inserted as `inactive` (await admin review).
             */
            added: Array<string>;
            /**
             * Registry slugs marked `obsolete` (no longer on the live API).
             */
            obsoleted: Array<string>;
            /**
             * Previously `obsolete` slugs found live again, set back to `inactive`.
             */
            reactivated: Array<string>;
        }>;
        added: number;
        obsoleted: number;
        reactivated: number;
        /**
         * Number of providers skipped (missing key or fetch error).
         */
        skipped: number;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/pipeline/llm-models/sync',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * Get aggregated AI cost statistics
     * @param from
     * @param to
     * @param groupBy
     * @param source Filter by cost source tag. 'pipeline' matches untagged rows. Leave empty for all.
     * @param employeeId Scope the stats to a single AI employee (matches tags->>'employee_id'). Implies source=aiemployee.
     * @returns any Cost statistics
     * @throws ApiError
     */
    public static getCostStats(
        from: string,
        to: string,
        groupBy: 'batch' | 'run' | 'stage' | 'model' | 'day' | 'source' | 'employee' | 'kind' | 'subagent' = 'batch',
        source?: 'pipeline' | 'aiemployee',
        employeeId?: string,
    ): CancelablePromise<{
        summary: {
            total_cost: number;
            total_tokens: number;
            /**
             * Input tokens kept out of model calls by tool-output reduction over this period. Gain ratio = saved_tokens / (total_tokens + saved_tokens).
             */
            saved_tokens: number;
            /**
             * Tokens removed from the working context by history compaction over this period (sum of input-minus-summary on compaction calls).
             */
            summarized_tokens: number;
            total_calls: number;
            run_count: number;
            avg_cost_per_run: number;
        };
        rows: Array<{
            group_key: string;
            group_label: string;
            call_count: number;
            sum_tokens: number;
            avg_tokens: number;
            avg_latency_ms: number;
            sum_cost: number;
            avg_cost: number;
        }>;
        time_series: Array<paths_1api_1v1_1pipeline_1cost_stats_get_responses_200_content_application_1json_schema_properties_rows_items>;
        by_model: Array<paths_1api_1v1_1pipeline_1cost_stats_get_responses_200_content_application_1json_schema_properties_rows_items>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/pipeline/cost-stats',
            query: {
                'from': from,
                'to': to,
                'groupBy': groupBy,
                'source': source,
                'employeeId': employeeId,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
}
